import { Submission } from '../types';

/**
 * Sets the Datadog user context based on submission details
 * @param submission - The submission object containing user details
 */
export const setDatadogUser = (submission: Submission | null | undefined) => {
  if (!window.DD_RUM || !window.DD_RUM.setUser) {
    return;
  }

  // If the submission has an email, set the user context
  if (submission?.details?.email) {
    window.DD_RUM.setUser({
      email: submission.details.email,
      id: submission.publicId, // Use publicId as a ID in Datadog
      name: `${submission.details.firstName} ${submission.details.lastName}`,
      company: submission.details.company,
    });
  }
};
